<template>
    <el-dialog
            :title="titleName"
            :visible.sync="visible"
            @close="handleClose"
            :append-to-body="true">
        <el-radio-group v-model="currentRadioInfo.msgType" @change="radioChange">
            <el-radio label="text">发送文字/链接</el-radio>
            <el-radio label="image">发送图片</el-radio>
            <el-radio label="news">发送图文消息</el-radio>
        </el-radio-group>
        <div class="menu-setting-item content">
            <div v-if="msgAction === 1">
                关键词:
                <el-input class="menu-name-input keyword-input"
                          v-model="currentRadioInfo.keyword"
                          placeholder="请输入关键词"></el-input>
            </div>
            <div v-if="currentRadioInfo.msgType ==='text'">
                文字/链接:<br/>
                <el-input class="text-area-input"
                          v-model="currentRadioInfo.content"
                          rows="10"
                          type="textarea"
                          maxlength="300"
                          show-word-limit
                          placeholder="请输入文字/链接"></el-input>
            </div>
            <div v-if="currentRadioInfo.msgType ==='image'">
                <el-button icon="el-icon-folder" @click="materials">从素材库选择</el-button>
                <el-upload
                        action=""
                        class="upload-demo"
                        multiple
                        :show-file-list="false"
                        :on-success="uploadSuccess"
                        :http-request="uploadFile"
                        :limit="1">
                    <el-button icon="el-icon-picture">上传图片</el-button>
                </el-upload>
                <div class="media-id content">
                    media_id:
                    <el-input class="menu-name-input menu-setting-item-content"
                              v-model="currentRadioInfo.mediaId"
                              placeholder="请输入mediaId">
                    </el-input>
                </div>
                <ImageShowDialog v-if="materialStatus" :show.sync="materialStatus"
                                 @itemClick="imageItemClick"/>
            </div>
            <div v-if="currentRadioInfo.msgType ==='news'">
                <NewsShow @itemClick="newsItemClick"/>
            </div>
        </div>
        <el-button type="primary" class="confirm" @click="addClick">确认</el-button>
    </el-dialog>
</template>

<script>
    import ImageShowDialog from "../components/ImageShowDialog"
    import NewsShow from "../components/NewsShow";

    export default {
        name: "AddKeyWordMessageReply",
        components: {
            ImageShowDialog,
            NewsShow
        },
        props: {
            show: {
                type: Boolean,
                default: false
            },
            titleName: {
                type: String,
                default: ''
            },
            msgAction: Number
        },
        data() {
            return {
                visible: this.show,
                materialStatus: false,
                currentRadioInfo: {
                    msgAction: this.msgAction,
                    msgType: "text"
                }
            }
        },
        watch: {
            show(val) {
                this.visible = val;
            },
        },
        methods: {
            radioChange() {
            },
            handleClose() {
                this.$emit('update:show', false);
                this.$emit("handleClose");
                this.currentRadioInfo.msgType = "text";
            },
            materials() {
                this.materialStatus = !this.materialStatus;
            },
            uploadSuccess() {
                this.$message({
                    message: '文件上传成功',
                    type: 'success'
                })
            },
            uploadFile(fileInfo) {
                let param = new FormData();
                param.append('file', fileInfo.file);
                this.$api.material.addMaterial(param).then(data => {
                    fileInfo.onSuccess(data);
                });
            },
            imageItemClick(item) {
                this.currentRadioInfo.mediaId = item.media_id;
                this.materialStatus = false;
            },
            newsItemClick(item) {
                let newsItems = [];
                for (let new_item of item.content.news_item) {
                    let temp = {
                        title: new_item.title,
                        description: new_item.digest,
                        picUrl: new_item.thumb_url,
                        url: new_item.url
                    };
                    newsItems.push(temp)
                }
                this.currentRadioInfo.content = JSON.stringify(newsItems);
            },
            addClick() {
                this.currentRadioInfo.msgAction = this.msgAction;
                window.console.log(this.currentRadioInfo);
                this.$api.messageReply.addMessage(this.currentRadioInfo).then(data => {
                    window.console.log(data);
                    this.$message({
                        message: "添加成功",
                        type: "success"
                    });
                    this.visible = false;
                });
            }
        }
    }
</script>

<style scoped>
    .menu-setting-item {
        margin: 15px 0;
    }

    .menu-name-input {
        width: 300px;
    }

    .text-area-input {
        margin-top: 5px;
        width: 400px;
    }

    .setting {
        margin-left: 25px;
        width: 505px;
        text-align: left;
        padding: 20px 10px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
    }

    .content {
        border: 1px solid #DCDFE6;
        border-radius: 2px;
        padding: 20px 10px;
    }

    .upload-demo {
        width: 120px;
        display: inline-block;
        margin-left: 10px;
    }

    .media-id {
        margin-top: 10px;
    }

    .menu-setting-item.content > span {
        float: top;
    }

    .keyword-input {
        margin-bottom: 10px;
    }

</style>